export default __webpack_public_path__ + "static/media/862.17afe450.gif";